import { render } from "./ProfileModal.vue?vue&type=template&id=1f3541db&scoped=true&ts=true"
import script from "./ProfileModal.vue?vue&type=script&lang=ts"
export * from "./ProfileModal.vue?vue&type=script&lang=ts"

import "./ProfileModal.vue?vue&type=style&index=0&id=1f3541db&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3541db"]])

export default __exports__